import { useEffect } from "react";
import { CheckCircle2 } from "lucide-react";

import { AlluLogo } from "@/components/parceiros/AlluLogo";
import { WhatsappHelp } from "@/components/parceiro-cadastro/WhatsappHelp";

const PAGE_TITLE = "Cadastro recebido — Allu";

const ParceiroCadastroObrigado = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;

    const robotsMeta = document.querySelector('meta[name="robots"]');
    const prevRobots = robotsMeta?.getAttribute("content") ?? "";
    robotsMeta?.setAttribute("content", "noindex, nofollow");

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyColor = document.body.style.color;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#FAF8F5";
    document.body.style.color = "#112711";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    return () => {
      document.title = prevTitle;
      robotsMeta?.setAttribute("content", prevRobots);
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = prevBodyColor;
      document.body.style.fontFamily = prevBodyFont;
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-[#FAF8F5] text-[#112711] flex flex-col"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <header className="border-b border-zinc-200/70">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-5">
          <AlluLogo variant="dark" className="h-8 sm:h-9 w-auto" />
        </div>
      </header>

      <main className="flex-1 flex items-center">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16 w-full text-center">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6 bg-[#D1F8E2] ring-8 ring-[#D1F8E2]/40">
            <CheckCircle2 className="w-8 h-8 text-[#112711]" />
          </span>

          <h1
            className="text-3xl sm:text-4xl font-medium text-[#112711] leading-tight"
            style={{
              fontFamily:
                '"Playfair Display", Georgia, "Times New Roman", serif',
              letterSpacing: "-0.01em",
            }}
          >
            Cadastro recebido
          </h1>

          <p className="mt-5 text-base sm:text-lg text-zinc-600 leading-relaxed max-w-xl mx-auto">
            Seus dados foram enviados. Em até 48h nossa equipe vai entrar em
            contato para orientar sobre a assinatura do contrato e sobre o
            processo de onboarding.{" "}
            <span className="font-semibold text-[#112711]">
              Fique atento ao telefone e ao WhatsApp no número que você passou.
            </span>
          </p>
        </div>
      </main>

      <WhatsappHelp />
    </div>
  );
};

export default ParceiroCadastroObrigado;
